import localforage from "localforage";

localforage.config({
  driver: localforage.LOCALSTORAGE,
  storeName: "excelite",
});

export default localforage;
